import { getEnvName } from '../../constants/environment';

/**
 * LaunchDarkly Configuration Module
 * 
 * Provides user configuration utilities for LaunchDarkly integration.
 * The client-side ID is now fetched at runtime via SdkKeysService (SFMLCM016-899).
 */

// DEPRECATED: LAUNCHDARKLY_CLIENT_SIDE_ID removed — now fetched at runtime via SdkKeysService

/**
 * Creates default anonymous user configuration for LaunchDarkly
 * Used when no authenticated user context is available
 */
export const getDefaultUser = () => ({
  key: 'anonymous-user',
  anonymous: true,
  custom: {
    environment: getEnvName(),
    application: 'condo-ui',
    hostname: window.location.hostname,
    timestamp: Date.now()
  }
});

/**
 * Creates authenticated user configuration for LaunchDarkly targeting
 * @param {string} userId - Unique user identifier
 * @param {object} userAttributes - Additional user attributes for targeting
 * @returns {object} LaunchDarkly user configuration
 */
export const createUser = (userId, userAttributes = {}) => ({
  key: userId,
  anonymous: false,
  ...userAttributes,
  custom: {
    environment: getEnvName(),
    application: 'condo-ui',
    hostname: window.location.hostname,
    authenticatedAt: Date.now(),
    ...userAttributes.custom
  }
});
